module.exports = __webpack_public_path__ + "static/media/frog(21).09048c2f.PNG";